import type { Art, Category } from '../types';
// The list itself lives in categories.json so the reel generator (plain node)
// reads the same file the app does — a renamed position can never be right in
// one place and stale in the other. See scripts/make-reels.mjs.
import data from './categories.json';

export const categories: Category[] = data as Category[];

/**
 * Positions valid for a set of arts — what the submit form offers.
 *
 * Position vocabularies genuinely differ by art: wrestling names positions
 * from the top (rides and turns), BJJ from the bottom (guards), so a wrestler
 * should never be asked to choose De la Riva and a BJJ player never Leg Lace.
 * A clip tagged for several arts gets the union, since it has to be filable
 * under whichever of them it actually happens in.
 *
 * Deliberately NOT derived from the live catalog the way the Library's chip
 * row is (see AppShell's availableCategoryIds): here there is no clip yet, so
 * deriving would mean the first clip in a position could never be filed there.
 */
export function categoryInArts(c: Category, arts: Art[]): boolean {
  return (c.arts ?? ['bjj']).some((a) => arts.includes(a));
}

export function categoriesForArts(arts: Art[]): Category[] {
  if (arts.length === 0) return [];
  return categories.filter((c) => categoryInArts(c, arts));
}
